export default __webpack_public_path__ + "static/media/SG.1557b84e.svg";